class Data {
  getSED() {
    return [
      {
        "text": "Shower gel",
        "value": "18.67"
      },
      {
        "text": "Shampoo",
        "value": "10.46"
      },
      {
        "text": "Hair conditioner",
        "value": "3.92"
      },
      {
        "text": "Hair styling products",
        "value": "4"
      },
      {
        "text": "Body lotion",
        "value": "7.82"
      },
      {
        "text": "Face Cream",
        "value": "1.54"
      },
      {
        "text": "Hand Cream",
        "value": "2.16"
      },
      {
        "text": "Liquid foundation, BB cream",
        "value": "0.51"
      },
      {
        "text": "Lipstick, lip salve",
        "value": "0.057"
      },
      {
        "text": "Make-up remover",
        "value": "5"
      },
      {
        "text": "Eye shadow",
        "value": "0.02"
      },
      {
        "text": "Concealer",
        "value": "0.51"
      },
      {
        "text": "Mascara",
        "value": "0.025"
      },
      {
        "text": "Eyeliner",
        "value": "0.005"
      },
      {
        "text": "Deodorant non-spray",
        "value": "1.5"
      },
      {
        "text": "Deodorant spray",
        "value": "0.69"
      },
      {
        "text": "Deodorant aerosol spray (ethanol based) ",
        "value": "1.43"
      },
      {
        "text": "Toothpaste",
        "value": "2.75"
      },
      {
        "text": "Mouthwash",
        "value": "21.62"
      },
      {
        "text": "Blusher, highlighter, bronzer",
        "value": "0.51"
      },
      {
        "text": "Nail polish",
        "value": "0.3"
      },
      {
        "text": "Nail polish remover",
        "value": "2.7"
      },
      {
        "text": "Hand wash soap",
        "value": "20"
      },
      {
        "text": "Eau de toilette, perfume spray",
        "value": "0.69"
      },
      {
        "text": "Shaving cream",
        "value": "1.54"
      },
      {
        "text": "Aftershave",
        "value": "1.54"
      }
    ];
  }
}

export default new Data();